module.exports = __webpack_public_path__ + "img/tag1.7d4cd73c.png";